var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-view',{attrs:{"title":_vm.title}},[_c('iframe',{staticClass:"frame",attrs:{"src":_vm.src,"frameborder":"0","scrolling":"auto"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }